import "./LegalInformation.css";

function LegalInformation(): JSX.Element {
    return (
        <div className="LegalInformation">
            <p>
                Vasilenko Car Rental LTD.&nbsp;
            </p>
            <p>
                Established by Alexander Vasilenko 2023 All rights reserved©️
                Klauzner 8 st, Ra'anana Israel.
            </p>
        </div>
    );
}

export default LegalInformation;
